import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  pointer: {
    cursor: 'pointer !important',
  },
}));
